import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "code", "phoneNumberId", "wabaId", "token" ]

  static values = {
    token: String,
    configId: String
  }

  phoneNumberId;
  wabaId;
  authCode;

  connect() {

    window.addEventListener("message", (event) => {
      if (!["https://www.facebook.com", "https://web.facebook.com"].includes(event.origin)) {
        console.warn("Origin not allowed:", event.origin);
        return;
      }

      try {
        const data = JSON.parse(event.data);
        if (data.type === "WA_EMBEDDED_SIGNUP" && data.event === "FINISH") {
          this.phoneNumberId = data.data.phone_number_id;
          this.wabaId = data.data.waba_id;
          this.sendToBackend();
        }
      }catch(e){
        return
      }
    });
  }

  launchSignup() {
    FB.login((response) => this.handleFBLogin(response), {
      config_id: this.configIdValue,
      scope: "business_management, whatsapp_business_management, whatsapp_business_messaging",
      response_type: "code",
      override_default_response_type: true,
      extras: {
        setup: {},
        featureType: "",
        sessionInfoVersion: "3",
      },
    });
  }

  handleFBLogin(response) {
    if (response.authResponse) {
      this.authCode = response.authResponse.code;
      this.sendToBackend();
    }
  }

  sendToBackend() {
    if (this.wabaId && this.authCode && this.phoneNumberId && this.tokenValue) {
      this.showLoadingScreen();

      this.codeTarget.value = this.authCode;
      this.phoneNumberIdTarget.value = this.phoneNumberId;
      this.wabaIdTarget.value = this.wabaId;
      this.tokenTarget.value = this.tokenValue;

      this.element.submit();
    }
  }

  showLoadingScreen() {
    const overlay = document.getElementById('loading-overlay');
    if (overlay) {
      overlay.style.display = 'flex';
    }
  }

  hideLoadingScreen() {
    const overlay = document.getElementById('loading-overlay');
    if (overlay) {
      overlay.style.display = 'none';
    }
  }
}
